import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const HomePage = lazy(() => import("../pages/home/page"));
const LoginPage = lazy(() => import("../pages/login/page"));
const ResetPasswordPage = lazy(() => import("../pages/reset-password/page"));
const ChangePasswordPage = lazy(() => import("../pages/change-password/page"));
const AlumniManagementPage = lazy(() => import("../pages/alumni-management/page"));
const DirectoryPage = lazy(() => import("../pages/directory/page"));
const NotFoundPage = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/reset-password",
    element: <ResetPasswordPage />,
  },
  {
    path: "/change-password",
    element: <ChangePasswordPage />,
  },
  {
    path: "/alumni-management",
    element: <AlumniManagementPage />,
  },
  {
    path: "/directory",
    element: <DirectoryPage />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];

export default routes;
